import api from "@/api"
import store from '../store'

export const getFairConfig = async () => {
    try {
        const res = await api.getFairConfig();
        let isPublic = Number(res.data.FC_PUBLIC) == 1;
        localStorage.setItem("public", isPublic);
        store.dispatch('updateFairConfig', res.data.data);
        return res.data.data
    } catch (error) {
        console.warn(error);
    }
};

export const checkSession = async () => {
    try {
        await api.checkSession();
        store.dispatch('setLoggedIn', true);
    } catch (error) {
        console.warn(error);
    }
};

export const getPermissions = async () => {
    try {
        const res = await api.getUserPermissions();
        store.dispatch('setPermissions', res.data.result);
    } catch (error) {
        console.warn(error);
    }
};

export const getPublicPermissions = async () => {
    try {
        const res = await api.getPublicPermissions();
        store.dispatch('setPublicPermissions', res.data.permissions);
    } catch (error) {
        console.warn(error);
    }
};